import { Avatar, alpha } from '@mui/material';

// primary/secondary have no hand-tuned pale `light` color (unlike the
// semantic severities), so their auto-derived `light` stays too dark/
// saturated to contrast against the `main`-colored icon on top of it.
const SEVERITIES_WITHOUT_TUNED_LIGHT = ['primary', 'secondary'];

const IconAvatar = ({ width, height, severity, children }) => {
  return (
    <Avatar
      sx={theme => ({
        color: theme.palette[severity].main,
        bgcolor:
          theme.palette.mode === 'light'
            ? SEVERITIES_WITHOUT_TUNED_LIGHT.includes(severity)
              ? alpha(theme.palette[severity].main, 0.12)
              : theme.palette[severity].light
            : 'inherit',
        border:
          theme.palette.mode === 'light'
            ? 'none'
            : `1px solid ${theme.palette[severity].main}`,
        width,
        height,
      })}
    >
      {children}
    </Avatar>
  );
};
export default IconAvatar;
